import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.authoring.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { formatKstDateTime } from "src/libs/portal/season/time";

@Component({
    selector: 'wiz-page-authoring-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.authoring.dashboard/view.scss */
@charset "UTF-8";
:host {
  display: block;
}

.dashboard-page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 30px 32px 48px;
}

.page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 22px;
}

.page-header h1 {
  margin: 0;
  color: #243a34;
  font-size: 25px;
  letter-spacing: -0.025em;
}

.page-header p {
  margin: 7px 0 0;
  color: #74827d;
  font-size: 13px;
}

.primary-action {
  height: 38px;
  display: inline-flex;
  align-items: center;
  padding: 0 16px;
  border-radius: 8px;
  color: #fff;
  background: #176d54;
  font-size: 12px;
  font-weight: 750;
  text-decoration: none;
}

.primary-action:hover {
  background: #115b46;
}

.loading-line {
  height: 3px;
  overflow: hidden;
  margin-bottom: 18px;
  border-radius: 999px;
  background: #e4ebe8;
}

.loading-line span {
  width: 34%;
  height: 100%;
  display: block;
  border-radius: inherit;
  background: #24775f;
  animation: dashboard-loading 1.1s ease-in-out infinite alternate;
}

@keyframes dashboard-loading {
  from {
    transform: translateX(-20%);
  }
  to {
    transform: translateX(210%);
  }
}
.inline-error,
.attention-banner {
  min-height: 48px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 16px;
  border-radius: 10px;
  font-size: 12px;
}

.inline-error {
  border: 1px solid #edcaca;
  color: #8e4545;
  background: #fff6f6;
}

.inline-error button {
  margin-left: auto;
  border: 0;
  color: #8e4545;
  background: transparent;
  font-size: 11px;
  font-weight: 750;
  cursor: pointer;
}

.attention-banner {
  border: 1px solid #efd7ba;
  color: #855822;
  background: #fff9f0;
  text-decoration: none;
  gap: 10px;
}

.attention-banner > span:last-child {
  margin-left: auto;
  font-size: 11px;
  font-weight: 750;
}

.attention-icon {
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  background: #c68736;
  font-size: 12px;
  font-weight: 800;
}

.workflow-grid {
  display: grid;
  margin-bottom: 18px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.workflow-card {
  min-height: 154px;
  display: flex;
  padding: 17px 18px;
  border: 1px solid #dfe6e3;
  border-radius: 12px;
  color: inherit;
  background: #fff;
  flex-direction: column;
  text-decoration: none;
  transition: border-color 0.15s ease, transform 0.15s ease;
}

.workflow-card:hover {
  border-color: #a9c4ba;
  transform: translateY(-1px);
}

.workflow-card-head {
  display: flex;
  align-items: center;
}

.workflow-card-head svg {
  width: 16px;
  height: 16px;
  margin-left: auto;
  fill: none;
  stroke: #93a29d;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.workflow-step {
  color: #8a9893;
  font-size: 10px;
  font-weight: 750;
  letter-spacing: 0.08em;
}

.workflow-label {
  margin-top: 10px;
  color: #3f544d;
  font-size: 13px;
}

.workflow-value {
  display: flex;
  align-items: baseline;
  margin-top: 11px;
  gap: 6px;
}

.workflow-value strong {
  color: #203730;
  font-size: 25px;
  letter-spacing: -0.03em;
}

.workflow-value span {
  color: #65766f;
  font-size: 11px;
  font-weight: 700;
}

.workflow-card small {
  margin-top: auto;
  color: #8a9692;
  font-size: 10px;
}

.dashboard-grid {
  display: grid;
  align-items: start;
  grid-template-columns: minmax(0, 1.75fr) minmax(260px, 0.65fr);
  gap: 18px;
}

.recent-panel,
.operations-panel {
  overflow: hidden;
  border: 1px solid #dfe6e3;
  border-radius: 12px;
  background: #fff;
}

.section-header {
  height: 54px;
  display: flex;
  align-items: center;
  padding: 0 18px;
  border-bottom: 1px solid #e7ecea;
}

.section-header h2 {
  margin: 0;
  color: #31463f;
  font-size: 14px;
}

.section-header a {
  margin-left: auto;
  color: #1b7057;
  font-size: 11px;
  font-weight: 750;
  text-decoration: none;
}

.run-list {
  padding: 0 18px;
}

.run-row {
  min-height: 66px;
  display: grid;
  align-items: center;
  border-bottom: 1px solid #edf1ef;
  color: inherit;
  grid-template-columns: minmax(0, 1fr) auto 74px;
  text-decoration: none;
  gap: 16px;
}

.run-row:last-child {
  border-bottom: 0;
}

.run-row:hover .run-main strong {
  color: #126a50;
}

.run-main,
.run-main strong,
.run-main small {
  display: block;
  min-width: 0;
}

.run-main strong {
  overflow: hidden;
  color: #344a43;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.run-main small {
  overflow: hidden;
  margin-top: 5px;
  color: #909b97;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.run-status {
  min-width: 52px;
  padding: 5px 7px;
  border-radius: 6px;
  color: #687772;
  background: #f0f3f2;
  font-size: 10px;
  font-weight: 750;
  text-align: center;
}

.run-status[data-status=RUNNING] {
  color: #17634f;
  background: #e7f2ee;
}

.run-status[data-status=COMPLETED] {
  color: #345f87;
  background: #eaf1f7;
}

.run-status[data-status=FAILED] {
  color: #9a4949;
  background: #faecec;
}

.run-count {
  text-align: right;
}

.run-count strong,
.run-count small {
  display: block;
}

.run-count strong {
  color: #344a43;
  font-size: 13px;
}

.run-count small {
  margin-top: 3px;
  color: #919c98;
  font-size: 9px;
}

.panel-state {
  min-height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #84918c;
  flex-direction: column;
  font-size: 12px;
  gap: 10px;
}

.panel-state a {
  color: #176d54;
  font-size: 11px;
  font-weight: 750;
}

.operations-panel dl {
  margin: 0;
  padding: 5px 18px;
}

.operations-panel dl > div {
  min-height: 54px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #edf1ef;
}

.operations-panel dl > div:last-child {
  border-bottom: 0;
}

.operations-panel dt {
  color: #778680;
  font-size: 11px;
}

.operations-panel dd {
  margin: 0 0 0 auto;
  color: #334942;
  font-size: 12px;
  font-weight: 750;
}

@media (max-width: 980px) {
  .workflow-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 620px) {
  .dashboard-page {
    padding: 24px 16px 40px;
  }
  .page-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
  }
  .workflow-grid {
    grid-template-columns: 1fr;
    gap: 9px;
  }
  .workflow-card {
    min-height: 136px;
  }
  .run-row {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .run-count {
    display: none;
  }
}
/* 원천 데이터·QA 생성 화면과 같은 작업 패널 체계 */
.dashboard-page {
  min-height: 620px;
  box-sizing: border-box;
  margin: 24px auto 36px;
  padding: 0 22px 22px;
  border: 1px solid #dfe6e3;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(30, 50, 43, 0.03);
}

.page-header {
  min-height: 70px;
  margin: 0 -22px 22px;
  padding: 0 22px;
  border-bottom: 1px solid #e7ecea;
}

.page-header h1 {
  color: #172f27;
  font-size: 20px;
}

.page-header p {
  color: #697a73;
  font-size: 12px;
}

.workflow-card small, .run-main small, .run-count small {
  font-size: 11px;
}

.workflow-step, .run-status {
  font-size: 11px;
}

.workflow-label, .run-main strong {
  font-size: 13px;
}

@media (max-width: 620px) {
  .dashboard-page {
    margin: 14px;
    padding: 0 16px 20px;
  }
  .page-header {
    margin: 0 -16px 18px;
    padding: 14px 16px;
  }
}`],
})
export class PageAuthoringDashboardComponent implements OnInit {
    public loading: boolean = true;
    public loadError: string = '';
    public recentRuns: any[] = [];
    public metrics: any = this.emptyMetrics();
    public workflowCards: any[] = [];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadDashboard();
    }

    private emptyMetrics() {
        return {
            source_documents: 0,
            qa_datasets: 0,
            qa_runs: 0,
            qa_candidates: 0,
            qa_active: 0,
            qa_failed: 0,
            review_pending: 0,
            dataset_versions: 0
        };
    }

    private availableRoles() {
        let entries = this.service.auth.session.dataset_roles || [];
        let roles: string[] = [];
        entries.forEach((dataset: any) => (dataset.roles || []).forEach((role: string) => {
            if (roles.indexOf(role) < 0) roles.push(role);
        }));
        return roles;
    }

    public isSystemAdmin() {
        return this.service.auth.session.user_type === 'SYSTEM_ADMIN';
    }

    public canUseSources() {
        if (this.isSystemAdmin()) return true;
        let roles = this.availableRoles();
        return ['AUTHOR', 'DATASET_ADMIN', 'GENERATION_OPERATOR', 'REVIEW_ADMIN', 'RELEASE_ADMIN']
            .some((role: string) => roles.indexOf(role) >= 0);
    }

    public canUseGeneration() {
        if (this.isSystemAdmin()) return true;
        let roles = this.availableRoles();
        return ['AUTHOR', 'DATASET_ADMIN', 'GENERATION_OPERATOR', 'REVIEW_ADMIN', 'RELEASE_ADMIN']
            .some((role: string) => roles.indexOf(role) >= 0);
    }

    public canCreateGeneration() {
        if (this.isSystemAdmin()) return true;
        let roles = this.availableRoles();
        return ['AUTHOR', 'DATASET_ADMIN', 'GENERATION_OPERATOR']
            .some((role: string) => roles.indexOf(role) >= 0);
    }

    public canPublishReview() {
        if (this.isSystemAdmin()) return true;
        let roles = this.availableRoles();
        return roles.indexOf('DATASET_ADMIN') >= 0 || roles.indexOf('REVIEW_ADMIN') >= 0;
    }

    public canAdjudicate() {
        if (this.isSystemAdmin()) return true;
        let roles = this.availableRoles();
        return roles.indexOf('REVIEW_ADMIN') >= 0 || roles.indexOf('ADJUDICATOR') >= 0;
    }

    public canManageReviews() {
        return this.canPublishReview() || this.canAdjudicate();
    }

    public canRelease() {
        return this.isSystemAdmin() || this.availableRoles().indexOf('RELEASE_ADMIN') >= 0;
    }

    public reviewLink() {
        return this.canPublishReview() ? '/authoring/review-batches' : '/authoring/adjudications';
    }

    public primaryAction() {
        if (this.canCreateGeneration()) return { label: 'QA 생성', link: '/authoring/runs' };
        if (this.canManageReviews()) return { label: '검수 관리', link: this.reviewLink() };
        if (this.canRelease()) return { label: '결과 데이터셋', link: '/authoring/releases' };
        return { label: '저작 품질', link: '/authoring/quality' };
    }

    private buildWorkflowCards(values: any = {}) {
        let cards = [
            {
                label: '원천 데이터',
                value: values.source_documents || 0,
                unit: '문서',
                description: '등록된 원천 문서',
                link: '/authoring/sources',
                visible: this.canUseSources()
            },
            {
                label: 'QA 생성',
                value: values.qa_active || 0,
                unit: '진행',
                description: `QA 데이터셋 ${values.qa_datasets || 0}개`,
                link: '/authoring/runs',
                visible: this.canUseGeneration()
            },
            {
                label: '검수 관리',
                value: values.review_pending || 0,
                unit: '대기',
                description: '종료되지 않은 검수 배치',
                link: this.reviewLink(),
                visible: this.canManageReviews()
            },
            {
                label: '저작 품질',
                value: values.qa_candidates || 0,
                unit: 'QA',
                description: '원문·Instruction·Golden 검사',
                link: '/authoring/quality',
                visible: true
            },
            {
                label: '결과 데이터셋',
                value: values.dataset_versions || 0,
                unit: '버전',
                description: '동결·릴리스 데이터',
                link: '/authoring/releases',
                visible: this.canRelease()
            }
        ].filter((item: any) => item.visible);
        return cards.map((item: any, index: number) => Object.assign(
            item,
            { step: String(index + 1).padStart(2, '0') }
        ));
    }

    public async loadDashboard() {
        this.loading = true;
        this.loadError = '';
        try {
            let result: any = await this.service.request.post(
                '/api/datasets/dashboard',
                {}
            );
            if (result.code !== 200) {
                throw new Error(
                    result.data && result.data.message
                        ? result.data.message
                        : '대시보드 현황을 불러오지 못했습니다.'
                );
            }
            let dashboard = result.data.dashboard || {};
            this.metrics = Object.assign(
                this.emptyMetrics(),
                dashboard.metrics || {}
            );
            this.recentRuns = dashboard.recent_runs || [];
            this.workflowCards = this.buildWorkflowCards(this.metrics);
        } catch (error) {
            this.loadError = error && error.message
                ? error.message
                : '대시보드 현황을 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public number(value: any) {
        return Number(value || 0).toLocaleString('ko-KR');
    }

    public runQuery(run: any) {
        return {
            dataset_id: run.dataset_id,
            run_id: run.id
        };
    }

    public statusLabel(value: string) {
        let labels: any = {
            DRAFT: '설정 중',
            QUEUED: '대기',
            RUNNING: '실행 중',
            COMPLETED: '완료',
            FAILED: '실패',
            CANCELED: '취소'
        };
        return labels[value] || value || '-';
    }

    public formatDate(value: string) {
        return formatKstDateTime(value, '-');
    }
}

export default PageAuthoringDashboardComponent;